import { AutomatedAuditLoader, Select } from '@common/components';
import { Flex } from '@mantine/core';
import React, { useEffect, useRef, useState } from 'react';
import { shallowEqual } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import {
    fetchAllReports,
    fetchLatestDashboard,
    fetchReportSettings,
    fetchSiteList,
    fetchSpecificDashboard,
    fetchSpecificReport,
    getClientOrganizations,
    getCompanyWebsies,
    getJoinedOrganization,
    selectedSite,
    useAppDispatch,
    useAppSelector
} from 'src/store';
import styles from "./styles.module.scss";
import dayjs from 'dayjs';
import { apiInstance } from 'src/services/interceptor';


interface ISelectData {
    value: string;
    label: string;
}

type PropsType = {
    onSiteSelected?: (site:any) => void;
    onPrevSelected?: (audit:any) => void;
    websitesByRole: (websitesByRoleData:any) => void;
};

/**
 * Logic of this component
 * if the current user is an organisation( organizationsId ), he can get the organisations, sites within these organizations and the previous report of sites
 * if the current user is not an organisation , he can get the sites and previous report of sites.
*/

function NavigationsWebsitesOrganization({ onSiteSelected , onPrevSelected, websitesByRole }: PropsType) {
    const [sitelistSelect, setSitelistSelect] = useState<ISelectData[]>([]);
    const [organizationsSelect, setOrganizationsSelect] = useState<ISelectData[]>([]);
    const [prevAuditSelect, setPrevAuditSelect] = useState<ISelectData[]>([]);
    const [selectedPrevAudit, setSelectedPrevAudit] = useState<string>("");
    const [isOrganizationSelected, setIsOrganizationSelected] = useState(false);
    const { id } = useParams();
    const {
        companyWebsites,
        loadingCompanyWebsites,
        loadingGetOrganizationSites,
    } = useAppSelector((state) => state.organization, shallowEqual);
    const { auditLenght } = useAppSelector((state) => state.automatedReports, shallowEqual);

    const { loading:reportLoading , allReports,latestDashboard  } = useAppSelector((state) => state.automatedReports, shallowEqual);
    const {  company_id } = useAppSelector((state) => state.user.data, shallowEqual);
    let organizationsId = "" // delete this line  if you want to have the organisation drop down ( get this from user state 'organizationsId')
    const { data:sitesList , siteAdded } = useAppSelector((state) => state.siteList, shallowEqual);
    const { status , statusLoading  } = useAppSelector((state) => state.automatedReports, shallowEqual);
    const { isAuditStopped } = useAppSelector((state) => state.stopAudit, shallowEqual);

    const [selectedSiteDropDown, setSelectedSiteDropDown] = useState<any>('');
    const [selectedOrganization, setSelectedOrganization] = useState<string>(organizationsId ?? "");
    const dispatch = useAppDispatch();
    const siteRef = useRef<HTMLInputElement>(null);
    const prevRef = useRef<HTMLInputElement>(null);
    const [fomatedDate, setFomatedDate] = useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    const siteUUID = searchParams.get('siteUUID')
    

    // useEffect( () => { 
    //     if ( siteRef?.current ) {
    //         siteRef?.current?.focus()
    //     }
    // } , [siteRef])

    // useEffect( () => {
    //     if ( !sitesList || !sitesList.length ) {
    //         dispatch(fetchSiteList(''));
    //     }

    // } , [sitesList])



    function groupWebsiteIDsByRole(data: any) {
        let groupedData:any = null;
        let role = data.role;
        
        if(!role){
            if(data.flag != 'owner'){
                return;
            }
            role= 'admin'
        }
        if(!Array.isArray(data.websites)){
            return
        }
        const websiteIDs = data.websites.map((website:any) => website.id);
    
        // Grouping the website IDs under the corresponding role
        groupedData = {role,websiteIDs};
    
        return groupedData;
    }
    

    useEffect( ()=> {

        const getOrganizationsSites = async ()=>{
                
                const joindOrganisation = await apiInstance.post(`/reporttool/usermanagement/company/get-companies-and-websites`);
                let allSites:any = [];
                
                  if ( !joindOrganisation?.data?.data ) {
                        return;
                  }
                  const data =  joindOrganisation?.data?.data; 

                  let groupedResult:any = [];
                  const websitesWithLabelAndValue = data?.reduce((acc:any, item:any) => {
                    const _groupedResult = groupWebsiteIDsByRole(item);
                    
                    if(_groupedResult){
                        groupedResult.push(_groupedResult)
                    }
                    // Check if the item has the 'owner' flag
                    if (item.flag === 'owner') {
                        // Add websites from 'owner' items at the start of the array
                        if (Array.isArray(item.websites)) {
                            acc?.unshift(...item?.websites?.map((website:any,index:any) => {
                                allSites.push({
                                    label: website.name ?? website.site_name, // Mapping 'name' to 'label'
                                    value:website.id,     // Mapping 'id' to 'value'
                                    company_id:item?.id
                                });
                            return({
                                label: website.name ?? website.site_name, // Mapping 'name' to 'label'
                                value: index === 0 ? website.id  + '|' + item.company_name : website.id,     // Mapping 'id' to 'value'
                                company_id:item?.id

                            })}
                        
                        ));
                        }
                    } else {
                        if (Array.isArray(item.websites)) {
                            // Add websites from other items at the end of the array
                            acc?.push(...item?.websites?.map((website:any,index:any) => {
                                allSites.push({
                                    label: website.name || website.site_name, // Mapping 'name' to 'label'
                                    value:website.id,     // Mapping 'id' to 'value'
                                    company_id:item?.id

                                });
                                return({
                                label: website.name ?? website.site_name, // Mapping 'name' to 'label'
                                value: index === 0 ? website.id  + '|' + item.company_name+ ` (External)` : website.id,     // Mapping 'id' to 'value'
                                company_id:item?.id

                            })
                        }));
                        }
                    }
                    return acc;
                }, []);
                
                setSitelistSelect(websitesWithLabelAndValue);                               
                const currentSite = allSites?.find((s:any) => {    
                   return s.value === siteUUID
                })                
                if ( currentSite?.value ) {
                    setSelectedSiteDropDown( currentSite?.value )
                    localStorage.setItem('selectedSite', JSON.stringify(currentSite));
                    dispatch(selectedSite({ selectedSiteData: currentSite }));
                    dispatch(fetchAllReports({
                        id:currentSite?.value,
                    }));
                }
                websitesByRole(groupedResult);
                
        }
        getOrganizationsSites();

    } , [ organizationsId , sitesList , siteAdded])
    useEffect(() => {
        // get the list of previously site report if the user has selected site.
        if (allReports?.length) {            
            const audits = allReports.map((report: any) => ({
                label: dayjs.unix(report?.insertion_date).format('YYYY-MM-DD HH:mm:ss'),
                value: report?.id,
            }));
            setPrevAuditSelect(audits); 
            const value = audits[0]?.label
            setSelectedPrevAudit(value);
        }else {
            if (latestDashboard) {
                if (latestDashboard?.date == "no audits scanned" ) {
                    setPrevAuditSelect([{
                        label: 'No Audits Scanned',
                        value : "latestDashboard",
                    }]);
                     
                }else {
                    setPrevAuditSelect([{
                        label: latestDashboard?.date + ' ' + latestDashboard?.time,
                        value : "latestDashboard",
                    }]);
                }
                setSelectedPrevAudit("latestDashboard");
            }
            setPrevAuditSelect([{
                label: 'No Audits Scanned',
                value : "latestDashboard",
            }]);
            setSelectedPrevAudit("latestDashboard");
        }
    }, [allReports ,latestDashboard ]);

    const handleSelectedSite = (siteId: string) => {

        if ( !siteId ) return
        const _siteId =  siteId.split('|');

        let site = null;
        if ( organizationsId  ) {            
            site = companyWebsites?.data?.sitesResult.find((site: any) => site.id === siteId);
        }else {

            site = sitelistSelect.find((site: any) => {
                const parts = site.value.split('|');
                const _id =  parts[0];
                const _id2 =  _siteId[0];

                return _id  == _id2;
            });
        }
        
        if (!site) return;       
        
        localStorage.setItem('selectedSite', JSON.stringify(site));
        dispatch(selectedSite({ selectedSiteData: site }));

        if ( prevRef.current ){
            prevRef.current.focus();  
        }
        dispatch(fetchAllReports({
            id : _siteId[0],
        }));
        onSiteSelected?.({
            site_id : site.label,
            id : site.value
        });
    };

    const handleSelectPrevAudit  = (e:String) => {
        const audit = allReports.find((report: any) => String(report?.id) == e);
        onPrevSelected?.(audit)
    } 

    const handleSelectChange = (e: string, setValue: React.Dispatch<React.SetStateAction<string>>, callback?: () => void) => {
        if (!e) return;
        // setValue(e);
        callback?.();
    };
    const formatTimeLength = (timeInSeconds: number): string => {
        if (isNaN(timeInSeconds) || timeInSeconds < 0) return ''; // Handle invalid input
        
        const hours = Math.floor(timeInSeconds / 3600);
        const minutes = Math.floor((timeInSeconds % 3600) / 60);
        const seconds = Math.floor(timeInSeconds % 60);
      
        // Format the time components
        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
        const formattedSeconds = seconds.toString().padStart(2, '0');
      
        return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
      };
    useEffect(() => {      
        if(!auditLenght || !auditLenght?.TimeinSecs || !auditLenght?.startTime || !auditLenght?.endTime){
          return;
        }
        const lenghtOfTime = formatTimeLength(auditLenght.TimeinSecs);
        setFomatedDate(`Duration: ${lenghtOfTime}`);
        
    }, [auditLenght])

    useEffect(() => {
        if (status && !isNaN(Number(status.status.split('%')[0]))) {
          if ( !statusLoading ) {
            const timeoutId = setTimeout(() => {
                const audit = allReports[0];
                if ( audit && audit?.insertion_date) {
                    handleSelectPrevAudit(String(audit?.id))
                }
                return
            }, 3000);
            return () => clearTimeout(timeoutId)
          }
        }
    }, [status, statusLoading , isAuditStopped]);     
    return (
        <Flex gap={"sm"} align={"end"}>
            {/* { organizationsId &&

                <Select
                    placeholder='Organization or a Company'
                    className={styles.dropDown}
                    label='Organization or a Company'
                    variant="secondary"
                    withIcon
                    value={selectedOrganization}
                    data={organizationsSelect}
                    onChange={(e) => handleSelectChange(String(e), setSelectedOrganization, () => {
                        setIsOrganizationSelected(true);
                        dispatch(getCompanyWebsies({ company_id, organization_id: e }));
                     })}
                    {...{ ariaLabel: 'Select an Organization or a Company' }}
                />
            
            } */}
            {loadingGetOrganizationSites || loadingCompanyWebsites && <AutomatedAuditLoader />}
            <Select
                ref={siteRef}
                className={styles.dropDown}
                placeholder='Choose a Site'
                label='Choose a Site'
                variant="secondary"
                withIcon
                value={selectedSiteDropDown}
                data={sitelistSelect} 
                onChange={(e) => {
                    siteRef?.current?.focus()
                    handleSelectChange(String(e), setSelectedSiteDropDown, () => handleSelectedSite(String(e)))} 
                }
                error={organizationsId && !loadingCompanyWebsites && isOrganizationSelected && !companyWebsites?.data?.sitesResult ? 'No Sites Found For this Organisation' : null}
                // {...{ disabled: !isOrganizationSelected, ariaLabel: 'Select a Website' }}
                { ...{ariaLabel: 'Press the spacebar to open the dropdown and use the arrow keys to navigate. Press the Enter key to select a website and load the site audit details'}}
            />
            {   reportLoading  && <AutomatedAuditLoader />}
            <Select
                width='300px'
                ref={prevRef}
                className={styles.dropDown}
                placeholder='Choose a previously ran audit'
                label='Choose a previously ran audit'
                variant="secondary"
                withIcon
                value={selectedPrevAudit}
                data={prevAuditSelect}
                onChange={(e) =>{
                    prevRef?.current?.focus();
                    handleSelectChange(String(e), setSelectedPrevAudit, () => handleSelectPrevAudit(String(e)))}
                } 
                error={ prevAuditSelect.length == 0 && selectedSiteDropDown && allReports && allReports.length == 0 ? 'No Previous Reports for this site' : null}
                {...{ disabled: !selectedSiteDropDown, ariaLabel: 'Page reloads upon selection of site' }}
            />
            <Flex justify={"center"} align={"center"}>
            {
                fomatedDate ?
                <span style={{ fontSize: '20px' , fontWeight : '700'}} aria-label={`Page reloads upon selection of site`}>
                    {fomatedDate}
                </span>
                : ""
            }
            </Flex>
        </Flex>
    );
}

export default NavigationsWebsitesOrganization;
